// import { gotoLogonModule } from '../../components/Utils';
import { apiB2B } from '../axios-client';
import { mapResponseToCustomerModel, mapResponseToPerksInfoModel, mapResponseToPerksAvailableModel, mapResponseToPerksRedeemModel, mapResponseToChoosePerksActivateModel, mapResponseToChallengesInfoModel, mapResponseToChallengeAcceptModel, } from '../../utils/NetworkUtil';
import { B2B_ACCOUNT_REWARDS_AND_OFFERS_PATH, B2B_ACCOUNT_PERKS_AVAILABLE_PATH, B2B_ACCOUNT_PERKS_REDEEM_PATH, B2B_ACCOUNT_PERKS_INFO_OFFER_PATH, B2B_ACCOUNT_PERKS_INFO_PATH, B2B_ACCOUNT_PERKS_INFO_REWARDS_PATH, B2B_CHALLENGE_ACCEPT, B2B_CHALLENGE_INFO, B2B_CHALLENGE_INFO_V2, B2B_ACCOUNT_CHOOSE_PERK_ACTIVATE_PATH, } from '../../constants';
import { getTHDCustomer } from '../../utils/GeneralUtil';
import { newrelic, REWARDS_HUB_CHALLENGE_API_SUCCESS_LOAD, REWARDS_HUB_CHALLENGE_API_ERROR, REWARDS_HUB_CHALLENGE_JOIN_SUCCESS, REWARDS_HUB_CHALLENGE_JOIN_ERROR, } from '../../utils/newrelic';
var hasCredentials = function (cust) {
    if (cust === void 0) { cust = getTHDCustomer(); }
    return cust.svocID && cust.userID;
};
var apiStartTime = Date.now();
var emptyPromise = {
    IRewardsAndOffers: Promise.resolve({}),
    IPerksInfo: Promise.resolve({}),
    IPerksAvailable: Promise.resolve({}),
    IPerksRedeem: Promise.resolve({}),
    IChallengesInfo: Promise.resolve({}),
    IChoosePerksActivate: Promise.resolve({}),
};
var handleErrors = function (response, mapFunction) {
    // console.log({ response, mapFunction });
    // // if (response.status === 403) // then redirect to login
    // // if (response.status === 500)
    return mapFunction(response === null || response === void 0 ? void 0 : response.data);
};
export var accountApi = {
    rewardsAndOffersDetails: function () {
        if (!hasCredentials())
            return emptyPromise.IRewardsAndOffers;
        return apiB2B
            .get(B2B_ACCOUNT_REWARDS_AND_OFFERS_PATH)
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToCustomerModel(data);
        })
            .catch(function (_a) {
            var response = _a.response;
            return handleErrors(response, mapResponseToCustomerModel);
        });
    },
    perksInfoRewardsDetails: function () {
        if (!hasCredentials())
            return emptyPromise.IPerksInfo;
        return apiB2B
            .get(B2B_ACCOUNT_PERKS_INFO_REWARDS_PATH)
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToPerksInfoModel(data);
        })
            .catch(function (_a) {
            var response = _a.response;
            return handleErrors(response, mapResponseToPerksInfoModel);
        });
    },
    perksInfoOffersDetails: function () {
        if (!hasCredentials())
            return emptyPromise.IPerksInfo;
        return apiB2B
            .get(B2B_ACCOUNT_PERKS_INFO_OFFER_PATH)
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToPerksInfoModel(data);
        })
            .catch(function (_a) {
            var response = _a.response;
            return handleErrors(response, mapResponseToPerksInfoModel);
        });
    },
    perksInfoPerksDetails: function () {
        if (!hasCredentials())
            return emptyPromise.IPerksInfo;
        return apiB2B
            .get(B2B_ACCOUNT_PERKS_INFO_PATH)
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToPerksInfoModel(data);
        })
            .catch(function (_a) {
            var response = _a.response;
            return handleErrors(response, mapResponseToPerksInfoModel);
        });
    },
    perksAvailableDetails: function () {
        if (!hasCredentials())
            return emptyPromise.IPerksAvailable;
        return apiB2B
            .get(B2B_ACCOUNT_PERKS_AVAILABLE_PATH)
            .then(function (_a) {
            var data = _a.data;
            return mapResponseToPerksAvailableModel(data);
        })
            .catch(function (_a) {
            var response = _a.response;
            return handleErrors(response, mapResponseToPerksAvailableModel);
        });
    },
    perksRedeemDetails: function (requestData) {
        if (!hasCredentials())
            return emptyPromise.IPerksRedeem;
        return apiB2B
            .post(B2B_ACCOUNT_PERKS_REDEEM_PATH, {
            perkRedemptionRequest: requestData,
        })
            .then(function (res) {
            return mapResponseToPerksRedeemModel(res.data);
        })
            .catch(function (_a) {
            var response = _a.response;
            // Track perk redemption error
            return handleErrors(response, mapResponseToPerksRedeemModel);
        });
    },
    challengeAccept: function (requestData) {
        // Handle both old string format and new object format
        var challengeRequest = typeof requestData === 'string'
            ? { challengeId: requestData }
            : requestData;
        var challengeId = challengeRequest.challengeId;
        if (!hasCredentials())
            return emptyPromise.IChallengesInfo;
        // Build payload based on isV2 flag
        var payload = { challengeId: challengeId };
        if (challengeRequest.isV2) {
            payload.isV2 = true;
            if (challengeRequest.customerChallengeId) {
                payload.customerChallengeId = challengeRequest.customerChallengeId;
            }
        }
        return apiB2B
            .put(B2B_CHALLENGE_ACCEPT, {
            acceptChallengeRequest: payload,
        })
            .then(function (res) {
            // Track successful challenge accept
            newrelic.addPageAction(REWARDS_HUB_CHALLENGE_JOIN_SUCCESS, {
                result: 'success',
                challengeId: challengeId || 'unknown',
                responseTime: Date.now() - apiStartTime,
                statusCode: res.status,
                isV2: challengeRequest.isV2 || false,
            });
            return mapResponseToChallengeAcceptModel(res.data);
        })
            .catch(function (_a) {
            var _b;
            var response = _a.response;
            // Track challenge accept error
            newrelic.addPageAction(REWARDS_HUB_CHALLENGE_JOIN_ERROR, {
                result: 'error',
                challengeId: challengeId || 'unknown',
                errorType: 'api_error',
                responseTime: Date.now() - apiStartTime,
                statusCode: (response === null || response === void 0 ? void 0 : response.status) || 0,
                errorMessage: ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) || 'Unknown API error',
                isV2: challengeRequest.isV2 || false,
            });
            return handleErrors(response, mapResponseToChallengeAcceptModel);
        });
    },
    challengesInfo: function (useV2Endpoint) {
        var challengeInfoApiPath = useV2Endpoint
            ? B2B_CHALLENGE_INFO_V2
            : B2B_CHALLENGE_INFO;
        if (!hasCredentials()) {
            return emptyPromise.IChallengesInfo;
        }
        return apiB2B
            .get(challengeInfoApiPath)
            .then(function (_a) {
            var _b;
            var data = _a.data;
            // Track successful challenges info fetch
            newrelic.addPageAction(REWARDS_HUB_CHALLENGE_API_SUCCESS_LOAD, {
                result: 'success',
                apiEndpoint: 'challengesInfo',
                responseTime: Date.now() - apiStartTime,
                challengeCount: ((_b = data === null || data === void 0 ? void 0 : data.challenges) === null || _b === void 0 ? void 0 : _b.length) || 0,
            });
            return mapResponseToChallengesInfoModel(data);
        })
            .catch(function (_a) {
            var _b;
            var response = _a.response;
            // Track challenges info error
            newrelic.addPageAction(REWARDS_HUB_CHALLENGE_API_ERROR, {
                result: 'error',
                apiEndpoint: 'challengesInfo',
                errorType: 'api_error',
                responseTime: Date.now() - apiStartTime,
                statusCode: (response === null || response === void 0 ? void 0 : response.status) || 0,
                errorMessage: ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message) || 'Unknown API error',
            });
            return handleErrors(response, mapResponseToChallengesInfoModel);
        });
    },
    choosePerkActivate: function (activePerk) {
        if (!hasCredentials())
            return emptyPromise.IChoosePerksActivate;
        // B2B_ACCOUNT_CHOOSE_PERK_ACTIVATE_PATH
        return apiB2B
            .post(B2B_ACCOUNT_CHOOSE_PERK_ACTIVATE_PATH, {
            perkActivationRequest: activePerk,
        })
            .then(function (res) {
            return mapResponseToChoosePerksActivateModel(res.data, 'ACTIVE_PERK_SUCCESS');
        })
            .catch(function (response) {
            return handleErrors(response, mapResponseToChoosePerksActivateModel);
        });
    },
};
